<template>
     <!-- <van-card :thumb="cards.IconUrl">
        <div class="c_title" slot="title">
          {{cards.Title}}
        </div>
        <div class="c_desc" slot="desc">{{cards.SubTitle}}</div>
   
    </van-card> -->
    <div class="card_">
      <div class="card">
        <div class="c_img">
         <img  :src="cards.IconUrl"/>
        </div>
        <div class="c_content">
          <div class="c_title">
            {{cards.Title}}
          </div>
          <div class="c_desc">
            {{cards.SubTitle}}
          </div>
        </div>
      </div>
      
    </div>
</template>
<script>
export default {
    data() {
        return{
          li:null,
        }
    },
    props:['cards'],
    watch:{
      cards:{
        handler(newName, oldName) {
          this.li=newName
        },
      deep: true,
      immediate: true
      }
    }
}
</script>
<style lang="scss" scoped>
.card_{
  display: flex;
  flex-direction: column;
}
.card{
   
   height:6rem ;
   padding-right: 0.5rem;
   border-radius: 0.375rem;
   margin-bottom: 0.75rem;
   .c_img{
        text-align: left;
        float: left;
        width: 6rem;
        height: 6rem;
        display: block;
        margin-right: 1rem;
        overflow: hidden;
        position: relative;
       img{
        border-top-left-radius: 0.375rem;
        border-bottom-left-radius: 0.375rem;
        width: 100%;
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        min-height: 100%;
       } 
   }
   .c_content{
        padding-top: 1rem;
        letter-spacing: 0;
        flex: auto;
        .c_title{
         font-size: 1rem;
         font-weight: 500;
         line-height: 1.5rem;
         max-height:1.5rem;
         text-align: left;
        }
        .c_desc{
            font-size: 0.8125rem;
            letter-spacing: 0;
            line-height: 1rem;
            max-height:2rem;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space:unset;
            text-align: left;
        }
   }

}
    .van-card__content{
        
    }
</style>




// WEBPACK FOOTER //
// src/components/card.vue